module.exports = __webpack_public_path__ + "static/vue/img/swiper.7aca5b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/swiper.png
// module id = 4e8i
// module chunks = 1